import { useState } from "react";
import ReactGA from "react-ga4";
import {
  useLogout,
  useCurrentUser,
  useFetchOrganizationUsers,
  useFetchOrganizations,
} from "utils/hooks";
import { toast } from "react-toastify";

const useRemoveUserFromOrganization = () => {
  const { logOut } = useLogout();
  const { fetchOrganizationUsers } = useFetchOrganizationUsers();
  const { fetchOrganizations } = useFetchOrganizations();
  const { user } = useCurrentUser();
  const [removing, setRemoving] = useState(false);

  const removeUserFromOrganization = async (args: {
    member: { uuid?: string | null; email: string; status?: string };
  }) => {
    if (!args || !user) {
      return null;
    }

    setRemoving(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}`, {
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          query: `
              mutation {
                removeUserFromOrganization(
                userId: "${args.member.uuid}",
                email: "${args.member.email}",
                status: "${args.member.status}",
                )
              }
            `,
        }),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          organizationId: user.activeOrganizationId || "NA",
          permissionKey: "remove_organization_therapists",
        },
      });

      const resData = await res.json();

      if (res.ok) {
        ReactGA.event("user_removed_from_organization", {
          user_id: user?.id,
          removed_user_id: args.member.uuid,
          organization_id: user.activeOrganizationId,
          connection_was: args.member.status,
        });
        toast.success("User removed from organization");
        fetchOrganizations();
        fetchOrganizationUsers(user.activeOrganizationId || null);
        return resData.data.removeUserFromOrganization;
      }

      if (!res.ok) {
        if (resData.errors[0]?.message.includes("BRKN_6001")) {
          toast.warn("For security purposes please log in again.");
          logOut();
        } else {
          toast.error(
            `Hmm, something went wrong. ${resData.errors[0].message}`
          );
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setRemoving(false);
    }
  };

  return {
    removeUserFromOrganization,
    removing,
  };
};

export default useRemoveUserFromOrganization;
